import { useCallback, useEffect, useState } from 'react';
import { getDataSetsAPI } from '../common/services';

// Loads the organization's data-sets.
const useDataSets = () => {
    const [dataSets, setDataSets] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const refreshDataSets = useCallback(async () => {
        try {
            const { data } = await getDataSetsAPI();
            setDataSets(data?.items || []);
        } catch (error) {
            console.error('Error fetching data-sets', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        refreshDataSets();
    }, [refreshDataSets]);

    return { dataSets, isLoading, refreshDataSets };
};

export default useDataSets;
